module.exports = __webpack_public_path__ + "static/media/Galdisa_Oil roasted peanut snack with chili flavor.e9e32c5d.pdf";